import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { StaffEntity } from '@/entities/staff.entity';

@Component<ThanksMessageMixin>({
  computed: {
    ...mapGetters('staff', ['currentStaff']),
  },
})
export default class ThanksMessageMixin extends Vue {
  currentStaff!: StaffEntity;

  keySearch: string = null;

  get filter(): [string, string, any][] {
    const filter = [];
    if (this.keySearch) {
      filter.push(['search', '$cont', encodeURI(`%${this.keySearch}%`)]);
    }
    switch (this.$route.params.filter) {
      case 'for-you':
        filter.push(['staffToId', '$eq', this.currentStaff.id]);
        break;
      case 'from-me':
        filter.push(['staffFromId', '$eq', this.currentStaff.id]);
        break;
      default:
        break;
    }
    return filter;
  }

  get title() {
    switch (this.$route.params.filter) {
      case 'all':
        return this.$t('thanks.filter.all');
      case 'for-you':
        return this.$t('thanks.filter.forYou');
      case 'from-me':
        return this.$t('thanks.filter.fromMe');
      default:
        return '';
    }
  }
}
